import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-row">
                <img src={`${process.env.PUBLIC_URL}/logo-circle.png`} alt="i2r" className="footer-logo" />
                <span>IoT · Physical AI · On-Device AI · Data Science</span>
                <span className="address">10326 경기도 고양시 일산동구 동국로32 동국대학교 산학협력관 231호</span>
                <span className="footer-copy">&copy; {new Date().getFullYear()} i2r IoT PLC & Sensor. All rights reserved.</span>
            </div>
        </footer>
    );
};

export default Footer;
